import { render, staticRenderFns } from "./Giveup.vue?vue&type=template&id=6939380a&scoped=true&"
import script from "./Giveup.vue?vue&type=script&lang=js&"
export * from "./Giveup.vue?vue&type=script&lang=js&"
import style0 from "./Giveup.vue?vue&type=style&index=0&id=6939380a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6939380a",
  null
  
)

component.options.__file = "Giveup.vue"
export default component.exports